import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import r from "../managers/braze-instance.js";
import { MAX_PURCHASE_QUANTITY as or } from "../common/constants.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
import { validateCustomProperties as nt, validateCustomString as mt } from "../util/validation-utils.js";
import c from "../common/event-logger.js";
export function logPurchase(e, o, i, n, t) {
  if (!r.rr()) return !1;
  if (null == i && (i = "USD"), null == n && (n = 1), null == e || e.length <= 0) return E.error("logPurchase requires a non-empty productId, got \"".concat(e, "\", ignoring.")), !1;
  if (!mt(e, "log purchase", "the purchase name")) return !1;
  if (null == o || isNaN(parseFloat(o.toString()))) return E.error("logPurchase requires a numeric price, got ".concat(o, ", ignoring.")), !1;
  var s = parseFloat(o.toString()).toFixed(2);
  if (null == n || isNaN(parseInt(n.toString()))) return E.error("logPurchase requires an integer quantity, got ".concat(n, ", ignoring.")), !1;
  var D = parseInt(n.toString());
  if (D < 1 || D > or) return E.error("logPurchase requires a quantity >1 and <".concat(or, ", got ").concat(D, ", ignoring.")), !1;
  i = null != i ? i.toUpperCase() : i;
  if (-1 === ["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD", "BTC", "BTN", "BWP", "BYR", "BZD", "CAD", "CDF", "CHF", "CLF", "CLP", "CNY", "COP", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EEK", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GGP", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "IMP", "INR", "IQD", "IRR", "ISK", "JEP", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LTL", "LVL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRO", "MTL", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLL", "SOS", "SRD", "STD", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VEF", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "YER", "ZAR", "ZMK", "ZMW", "ZWL"].indexOf(i)) return E.error("logPurchase requires a valid currencyCode, got ".concat(i, ", ignoring.")), !1;
  var _nt = nt(t, "logPurchase", "purchaseProperties", "log purchase \"".concat(e, "\""), "purchase"),
    _nt2 = _slicedToArray(_nt, 2),
    u = _nt2[0],
    a = _nt2[1];
  if (!u) return !1;
  var g = r.l();
  if (g && g.Dr(e)) return E.info("Purchase \"".concat(e, "\" is blocklisted, ignoring.")), !1;
  var P = c.rt(m.Pr, {
    pid: e,
    c: i,
    p: s,
    q: D,
    pr: a
  });
  if (P.W) {
    E.info("Logged ".concat(D, " purchase").concat(D > 1 ? "s" : "", " of \"").concat(e, "\" for ").concat(i, " ").concat(s, "."));
    var _iterator = _createForOfIteratorHelper(P.ue),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r = _step.value;
        rt.o().ve(ot.Rr, [e, t], _r);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return P.W;
}